var connecting = false;

$(window).on('load, scroll', function() {
    if (!connecting) {
        activateConnections();
    }
});

function activateConnections() {
    if ($('.locations__map.animated').length > 0) {
        connecting = true;
        var changingConnections = setInterval(changePath, 2000);
    }
}

function changePath() {
    var noOfPaths = $('.locations__mapWrapper svg path').length;
    var $animate1 = $('#elec1');
    var $animate2 = $('#elec2');

    $animate1.attr(
        'path',
        $('.locations__mapWrapper .st9')
            .eq(Math.floor(Math.random() * noOfPaths))
            .attr('d')
    );
    $animate2.attr(
        'path',
        $('.locations__mapWrapper .st9')
            .eq(Math.floor(Math.random() * noOfPaths))
            .attr('d')
    );

    addShimmer(noOfPaths);
    setTimeout(addShimmer(noOfPaths), 200);
    setTimeout(addShimmer(noOfPaths), 400);
    setTimeout(addShimmer(noOfPaths), 600);
    setTimeout(addShimmer(noOfPaths), 800);
}

function addShimmer(noOfPaths) {
    var index = Math.floor(Math.random() * noOfPaths);
    $('.locations__mapWrapper .st9:not(".shimmer")')
        .eq(index)
        .addClass('shimmer');
}

centerMapMobile();

function centerMapMobile() {
    if (window.innerWidth < 1101) {
        var container = document.querySelector('.locations__mapContainer');
        var content = document.querySelector('.locations__mapWrapper');

        if (content && container) {
            var scrollLeft = (content.offsetWidth - container.offsetWidth) / 2;
            container.scrollLeft = scrollLeft;
        }
    }
}
